import { useQuery } from "@tanstack/react-query";
import { queryContants } from "../../constant";
import { getBanner, getNetStatus } from "../../apis/app";

export const useGetBannerQuery = () => {
  return useQuery({
    queryKey: [queryContants.GET_BANNER],
    queryFn: getBanner,
    refetchOnWindowFocus: false,
    staleTime: 10 * 60 * 1000, // 10 minutes - banners don't change often
  });
};

export const useGetNetStatus = (netId) => {
  const accessToken = localStorage.getItem("accessToken");
  return useQuery({
    queryKey: [queryContants.GET_NET_STATUS, netId],
    queryFn: () => getNetStatus(netId),
    enabled: !!accessToken && !!netId,
  });
};
